import Carousel from './Carrousel';
import Footer from './Footer';
import Content from './Content';

export default function Home() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  return (
    <div>
      <Carousel />
      <Content />
      <Footer />
    </div>
  )
};
